import { CellClickedEvent } from '@ag-grid-community/all-modules';
import React from 'react';
import './RowMenuButton.scss';

export const RowMenuButton: React.FC = () => (
    <button className="btn row-menu-button" data-testid="dot-menu-btn">
        <i className="material-icons">more_vert</i>
    </button>
)

export function handleRowMenuClick(ev: CellClickedEvent) {
    //Programatically displaying the context menu is not supported by the library, but this hack makes it work
    //It's possible that a future version of the library will break this
    //https://github.com/ag-grid/ag-grid-enterprise/issues/72
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- hack to access private method, see above
    const api: any = ev.api;
    api.contextMenuFactory.showMenu(ev.node, ev.column, ev.value, ev.event);
}